/*
  HANNE BLOCH bikini mix & match (HB 2026-10-21, round 80; Vic's pick W1 of the wireframes of 21 Oct, DECISIONS 161;
  HB 2026-10-23, Julie's round: the tops as pictures too, the Description tab following the bottom).
  The script behind snippets/hb-mix on the product page (ctx pdp) and in the Mini PDP (ctx qv, sections/hb-qv).

  The rows: TOP and the chosen top's sizes, the tops as pictures, the bottoms as pictures, BOTTOM and the chosen
  bottom's sizes. This keeps her choice (the top, its size, the bottom, its size), paints the rows and the price,
  writes the two pieces into the product form as items[0] and items[1] (assets/product-form.js already posts a form
  that way), swaps the Description tab's text for the chosen bottom's own, and hands the Mini PDP's script the same
  two items (window.HBMix.items). The sizes follow the site's rule: her remembered size (hb-size) when it is in
  stock, else M, else the nearest size in stock; the bottom's size follows the top's until she sets it herself; a
  swapped piece keeps her size when it has it, else the nearest in stock.

  The two lines are marked for the cart (snippets/hb-cart-lines, hb-cart-line, assets/hb-cart.js): _hb_mix (one key
  per set, new for every add, so two sets never merge), _hb_mix_role (top | bottom), _hb_mix_top (the top's
  handle) and _hb_mix_page (the handle of the bikini's page it was added from: both lines link there in the cart, never
  to the hidden top or bottom; HB 2026-11-03).

  Nothing here for a page without the block; the theme's own variant picker stays in the document but hidden
  (assets/hb-mix.css) and assets/hb-pdp.js leaves its sizes alone on a mix page.
*/
(function () {
  'use strict';
  if (window.HBMix) return;

  var ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '3XL'];
  var RANK = ['M', 'L', 'S', 'XL', 'XS', 'XXL', 'XXS', 'XXXL', '3XL'];
  var LETTER = /^(XXS|XS|S|M|L|XL|XXL|XXXL|3XL)$/i;
  var up = function (s) { return String(s == null ? '' : s).trim().toUpperCase(); };

  function remembered() {
    try { return up(localStorage.getItem('hb-size')); } catch (e) { return ''; }
  }
  function remember(size) {
    if (!LETTER.test(up(size))) return;
    try { localStorage.setItem('hb-size', up(size)); } catch (e) { /* nothing */ }
  }
  function text(html) {
    var d = document.createElement('div');
    d.innerHTML = html == null ? '' : String(html);
    return (d.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function newKey() {
    return 'm' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }

  /* ---------- sizes ---------- */
  function inStock(variants, size) {
    return variants.some(function (v) { return v.a && up(v.size) === up(size); });
  }
  function hasSize(variants, size) {
    return variants.some(function (v) { return up(v.size) === up(size); });
  }
  // Her size when it is in stock, else the nearest size in stock (one up, one down, two up, ...), else M-L-S-XL-XS
  function nearest(variants, want) {
    want = up(want);
    if (want && inStock(variants, want)) return want;
    var i = ORDER.indexOf(want);
    if (i !== -1) {
      for (var d = 1; d < ORDER.length; d += 1) {
        if (inStock(variants, ORDER[i + d])) return ORDER[i + d];
        if (inStock(variants, ORDER[i - d])) return ORDER[i - d];
      }
    }
    for (var r = 0; r < RANK.length; r += 1) if (inStock(variants, RANK[r])) return RANK[r];
    var any = variants.filter(function (v) { return v.a; })[0];
    if (any) return up(any.size);
    if (want && hasSize(variants, want)) return want;
    return variants[0] ? up(variants[0].size) : '';
  }
  function firstSize(variants) {
    var pref = remembered();
    if (pref && inStock(variants, pref)) return pref;
    return nearest(variants, 'M');
  }
  function variantOf(piece, size) {
    if (!piece) return null;
    return piece.variants.filter(function (v) { return up(v.size) === up(size); })[0] || null;
  }

  /* ---------- the state, on the block itself ---------- */
  function readData(root) {
    try {
      var el = root.querySelector('[data-hb-mix-data]');
      var d = JSON.parse(el ? el.textContent : '{}');
      if (!d || !Array.isArray(d.tops) || !Array.isArray(d.bottoms)) return null;
      d.tops.forEach(function (t) { t.variants = t.variants || []; });
      d.bottoms.forEach(function (b) { b.variants = b.variants || []; });
      return d;
    } catch (e) {
      return null;
    }
  }
  function pieceOf(list, handle) {
    return list.filter(function (p) { return p.handle === handle; })[0] || null;
  }
  function topOf(s) { return pieceOf(s.data.tops, s.top); }
  function bottomOf(s) { return pieceOf(s.data.bottoms, s.bottom); }
  function firstOf(list, want) {
    var hit = want ? pieceOf(list, want) : null;
    if (hit && hit.a) return hit.handle;
    var on = list.filter(function (p) { return p.a; })[0];
    return (hit || on || list[0] || {}).handle || '';
  }

  function read(root) {
    var s = root.hbMix;
    if (!s) return null;
    var t = topOf(s);
    var b = bottomOf(s);
    var tv = variantOf(t, s.topSize);
    var bv = variantOf(b, s.botSize);
    var sum = bv && bv.sums && bv.sums[s.top] ? bv.sums[s.top] : (t ? t.price : '');
    return {
      ok: !!(tv && tv.a && bv && bv.a),
      key: s.key,
      top: t ? { handle: t.handle, name: t.name, id: tv ? tv.id : 0, size: s.topSize, price: tv ? tv.price : t.price } : null,
      bottom: b ? { handle: b.handle, name: b.name, id: bv ? bv.id : 0, size: s.botSize, price: bv ? bv.price : '' } : null,
      sum: sum,
      sumText: text(sum),
    };
  }

  // The two lines for the cart, in the order the cart shows them
  // HB 2026-11-03: each add is its own set. The product page passes its key (renewed on every submit); a caller without
  // one (the Mini PDP) used to get the sheet's first key on every add, so a second bikini from the same sheet would
  // join the first set in the cart (snippets/hb-cart-lines pairs one top with one bottom per key). Now it gets a new key.
  function items(root, key) {
    var r = read(root);
    if (!r || !r.ok) return null;
    key = key || newKey();
    var top = r.top.handle;
    var props = function (role) {
      var p = { _hb_mix: key, _hb_mix_role: role, _hb_mix_top: top };
      if (root.dataset.page) p._hb_mix_page = root.dataset.page;
      return p;
    };
    return [
      { id: r.top.id, quantity: 1, properties: props('top') },
      { id: r.bottom.id, quantity: 1, properties: props('bottom') },
    ];
  }

  /* ---------- the product form (pdp): items[0] and items[1] in place of the bundle's id ---------- */
  function formOf(root) {
    var pi = root.closest('.product-information') || document;
    return pi.querySelector('product-form-component form[data-type="add-to-cart-form"]') || pi.querySelector('product-form-component form');
  }
  function fieldsBox(form) {
    var box = form.querySelector('[data-hb-mix-fields]');
    if (box) return box;
    // The bundle's own variant and the form's line properties belong to the bundle: off, never sent with the set
    form.querySelectorAll('input[name="id"]').forEach(function (i) { i.name = 'hb_mix_id_off'; i.setAttribute('data-hb-mix-off', 'id'); });
    form.querySelectorAll('input[name^="properties["]').forEach(function (i) { i.disabled = true; i.setAttribute('data-hb-mix-off', 'prop'); });
    box = document.createElement('span');
    box.setAttribute('data-hb-mix-fields', '');
    box.hidden = true;
    form.appendChild(box);
    return box;
  }
  function hidden(name, value) {
    var i = document.createElement('input');
    i.type = 'hidden';
    i.name = name;
    i.value = String(value);
    return i;
  }
  function fillForm(root) {
    var s = root.hbMix;
    if (!s || s.ctx !== 'pdp') return;
    var form = formOf(root);
    if (!form) return;
    var box = fieldsBox(form);
    box.textContent = '';
    var list = items(root, s.key);
    if (!list) return;
    list.forEach(function (it, n) {
      box.appendChild(hidden('items[' + n + '][id]', it.id));
      box.appendChild(hidden('items[' + n + '][quantity]', it.quantity));
      Object.keys(it.properties).forEach(function (k) {
        box.appendChild(hidden('items[' + n + '][properties][' + k + ']', it.properties[k]));
      });
    });
  }
  function paintButton(root, r) {
    var s = root.hbMix;
    var form = formOf(root);
    var btn = form && form.querySelector('[ref="addToCartButton"]');
    if (!btn) return;
    var tx = btn.querySelector('.cart-btn-text');
    if (tx && !s.btnText) s.btnText = tx.textContent;
    btn.disabled = !r.ok;
    if (tx) tx.textContent = r.ok ? s.btnText : 'Sold out';
    // HB 2026-11-02 (carried onto the live theme): live's button carries the price ("ADD TO CART · DKK 2,200", round
    // 46, Liquid writes the bundle's); on a mix page it shows the set's price, the top's plus the chosen bottom's
    var ap = btn.querySelector('.hb-atc__price');
    var sep = btn.querySelector('.hb-atc__sep');
    if (ap && r.ok && r.sumText) ap.textContent = r.sumText;
    if (ap) ap.style.display = r.ok ? '' : 'none';
    if (sep) sep.style.display = r.ok ? '' : 'none';
  }
  function paintPrice(root, r) {
    var pi = root.closest('.product-information') || document;
    pi.querySelectorAll('product-price').forEach(function (pp) {
      var el = pp.querySelector('.price .money') || pp.querySelector('.price');
      if (el && el.textContent.trim() !== r.sumText) el.textContent = r.sumText;
      pp.querySelectorAll('.compare-at-price, .discount_price').forEach(function (x) { x.hidden = true; });
    });
  }
  // HB 2026-10-23 (Julie, item 3): the Description tab's text follows the chosen bottom; a bottom without a
  // description of its own leaves the page's text as it was.
  // HB 2026-11-03 (team test: "the bikini description only focuses on the bottom"): with the bikini's own bottom (the
  // set's first) the tab keeps the page's text, the bikini's; only another bottom brings its own text.
  function paintDescription(root) {
    var s = root.hbMix;
    var pi = root.closest('.product-information') || document;
    var box = pi.querySelector('[data-hb-panel="description"] .hb-dx__desc');
    if (!box) return;
    if (s.descOrig == null) s.descOrig = box.innerHTML;
    var own = s.data.bottoms[0] ? s.data.bottoms[0].handle : '';
    var tpl = s.bottom === own ? null : root.querySelector('template[data-hb-mix-desc][data-for="' + s.bottom + '"]');
    var html = tpl ? tpl.innerHTML.trim() : '';
    var want = html || s.descOrig;
    if (box.innerHTML !== want) box.innerHTML = want;
  }

  /* ---------- painting the rows ---------- */
  function mark(el, on) {
    if (el instanceof HTMLInputElement) {
      el.checked = on;
      var label = el.closest('label');
      if (label) label.classList.toggle('is-on', on);
      return;
    }
    el.classList.toggle('is-on', on);
    el.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  function paint(root) {
    var s = root.hbMix;
    if (!s) return;
    root.dataset.top = s.top;
    root.querySelectorAll('[data-hb-mix-top]').forEach(function (t) {
      var on = t.dataset.hbMixTop === s.top;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-hb-mix-bottom]').forEach(function (t) {
      var on = t.dataset.hbMixBottom === s.bottom;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-for][data-kind]').forEach(function (row) {
      var isTop = row.dataset.kind === 'top';
      var mine = row.dataset.for === (isTop ? s.top : s.bottom);
      row.hidden = !mine;
      if (mine) {
        var size = isTop ? s.topSize : s.botSize;
        row.querySelectorAll('[data-hb-mix-size]').forEach(function (el) { mark(el, up(el.dataset.hbMixSize) === size); });
      }
    });
    var r = read(root);
    if (s.ctx === 'pdp') {
      fillForm(root);
      paintButton(root, r);
      paintPrice(root, r);
      paintDescription(root);
    }
    if (typeof s.onChange === 'function') s.onChange(r);
  }

  /* ---------- her taps ---------- */
  function pickTop(root, handle) {
    var s = root.hbMix;
    var t = pieceOf(s.data.tops, handle);
    if (!t || !t.a) return;
    s.top = handle;
    s.topSize = nearest(t.variants, s.topSize);
    if (!s.botTouched) {
      var b = bottomOf(s);
      if (b) s.botSize = nearest(b.variants, s.topSize);
    }
    paint(root);
  }
  function pickTopSize(root, size) {
    var s = root.hbMix;
    var t = topOf(s);
    size = up(size);
    if (!t || !hasSize(t.variants, size)) return;
    s.topSize = size;
    remember(size);
    if (!s.botTouched) {
      var b = bottomOf(s);
      if (b) s.botSize = nearest(b.variants, size);
    }
    paint(root);
  }
  function pickBottomSize(root, size) {
    var s = root.hbMix;
    var b = bottomOf(s);
    size = up(size);
    if (!b || !hasSize(b.variants, size)) return;
    s.botSize = size;
    s.botTouched = true;
    paint(root);
  }
  function pickBottom(root, handle) {
    var s = root.hbMix;
    var b = pieceOf(s.data.bottoms, handle);
    if (!b || !b.a) return;
    s.bottom = handle;
    s.botSize = nearest(b.variants, s.botSize || s.topSize);
    paint(root);
  }
  /* HB 2026-11-02 (Olivia: "the image also needs to be hooked up to a model image, so it changes based on the one I
     select"): on the product page the gallery's first picture shows the model picture of the piece she just tapped
     (snippets/hb-mix writes it on the tile, data-model); the page's own piece, or a piece without a model picture,
     brings the page's own first picture back. The phone's slideshow returns to its first slide; the page never scrolls.
     HB 2026-11-02 (Olivia: the front of the set first, the back view next): a piece with a picture from behind
     (data-model-back) shows it over the gallery's second picture the same way; without one, the second is the page's. */
  function layer(slide, url, set, alt) {
    if (!slide) return;
    var shot = slide.querySelector(':scope > .hb-mix-shot');
    if (!url) {
      if (shot) shot.classList.remove('is-in');
      return;
    }
    if (!shot) {
      shot = document.createElement('img');
      shot.className = 'hb-mix-shot';
      shot.decoding = 'async';
      shot.sizes = '50vw'; // HB 2026-11-03: half the width on the desktop grid and, side by side, on the phone
      slide.appendChild(shot);
    }
    if (shot.getAttribute('data-src') !== url) {
      shot.classList.remove('is-in');
      shot.setAttribute('data-src', url);
      shot.alt = alt || '';
      // fade in once the picture has arrived (at most 0.9 s later either way); a timer, not a frame or decode(), which
      // can wait indefinitely in a page the browser is not painting
      var shown = false;
      var show = function () {
        if (shown || shot.getAttribute('data-src') !== url) return;
        shown = true;
        setTimeout(function () { shot.classList.add('is-in'); }, 30);
      };
      shot.addEventListener('load', show, { once: true });
      setTimeout(show, 900);
      if (set) shot.srcset = set; else shot.removeAttribute('srcset');
      shot.src = url;
      if (shot.complete && shot.naturalWidth) show();
    } else {
      shot.classList.add('is-in');
    }
  }
  /* HB 2026-11-03 (Olivia: "Go ahead on zoom"): the zoom shows what the gallery shows. A tapped piece's front and back
     go into the zoom's first two pictures and their thumbnails; the page's own piece puts the page's pictures back (kept
     on each picture the first time, data-hb-o-*). */
  function zoomPic(img, url, set, alt) {
    if (!img) return;
    if (!img.hasAttribute('data-hb-o-src')) {
      img.setAttribute('data-hb-o-src', img.getAttribute('src') || '');
      img.setAttribute('data-hb-o-set', img.getAttribute('srcset') || '');
      img.setAttribute('data-hb-o-alt', img.getAttribute('alt') || '');
    }
    var src = url || img.getAttribute('data-hb-o-src');
    if (!src || img.getAttribute('src') === src) return;
    var srcset = url ? (set || '') : img.getAttribute('data-hb-o-set');
    if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
    img.setAttribute('src', src);
    img.setAttribute('alt', url ? (alt || img.getAttribute('data-hb-o-alt')) : img.getAttribute('data-hb-o-alt'));
  }
  function showZoom(pi, pics) {
    var zd = pi.querySelector('zoom-dialog');
    if (!zd) return;
    var big = zd.querySelectorAll('.dialog-zoomed-gallery > li');
    var thumbs = zd.querySelectorAll('.dialog-thumbnails-list > button');
    pics.forEach(function (p, i) {
      zoomPic(big[i] && big[i].querySelector('img'), p.url, p.set, p.alt);
      zoomPic(thumbs[i] && thumbs[i].querySelector('img'), p.url, p.set, p.alt);
    });
  }
  function showShot(root, tile, handle) {
    if (!root || root.dataset.ctx !== 'pdp') return;
    var pi = root.closest('.product-information') || document;
    // HB 2026-11-02: the phone's gallery is a slideshow, the desktop's a grid of pictures (the slideshow is there but
    // has no size); the pictures go on whichever one shows, and come off the other
    var slides = [].slice.call(pi.querySelectorAll('media-gallery slideshow-slide'));
    var grid = [].slice.call(pi.querySelectorAll('media-gallery .media-gallery__grid > li'));
    var shows = function (el) { return !!el && el.getBoundingClientRect().width > 0; };
    var use = shows(slides[0]) ? slides : (shows(grid[0]) ? grid : slides);
    if (!use.length) return;
    slides.concat(grid).forEach(function (el) {
      var i = use.indexOf(el);
      if (i < 0 || i > 1) layer(el, '');
    });
    var d = (tile && tile.dataset) || {};
    var on = !!d.model && handle !== root.dataset.page;
    /* HB 2026-11-03 (Olivia: the back first on the phone, then design A): the front on the first picture and the back
       on the second everywhere; on the phone the two show side by side with the second on the left (assets/hb-mix.css) */
    layer(use[0], on ? d.model : '', d.modelSet, d.modelAlt);
    layer(use[1], on ? (d.modelBack || '') : '', d.modelBackSet, d.modelBackAlt);
    showZoom(pi, [
      { url: on ? d.model : '', set: d.modelSet, alt: d.modelAlt },
      { url: on ? (d.modelBack || '') : '', set: d.modelBackSet, alt: d.modelBackAlt },
    ]);
    if (!on || use !== slides) return;
    var track = pi.querySelector('media-gallery slideshow-slides');
    if (track && track.scrollLeft > 0) {
      try { track.scrollTo({ left: 0, behavior: 'smooth' }); } catch (err) { track.scrollLeft = 0; }
    }
  }
  function onClick(e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    var root = t.closest('[data-hb-mix]');
    if (!root || !root.hbMix) return;
    var topTile = t.closest('[data-hb-mix-top]');
    if (topTile) {
      e.preventDefault();
      if (!topTile.classList.contains('is-out')) {
        pickTop(root, topTile.dataset.hbMixTop);
        showShot(root, topTile, topTile.dataset.hbMixTop);
      }
      return;
    }
    var tile = t.closest('[data-hb-mix-bottom]');
    if (tile) {
      e.preventDefault();
      if (!tile.classList.contains('is-out')) {
        pickBottom(root, tile.dataset.hbMixBottom);
        showShot(root, tile, tile.dataset.hbMixBottom);
      }
      return;
    }
    var pill = t.closest('button[data-hb-mix-size]');
    if (pill) {
      e.preventDefault();
      var group = pill.closest('[data-hb-mix-sizes]');
      if (!group) return;
      if (group.dataset.hbMixSizes === 'top') pickTopSize(root, pill.dataset.hbMixSize);
      else pickBottomSize(root, pill.dataset.hbMixSize);
    }
  }
  function onChange(e) {
    var t = e.target;
    if (!(t instanceof HTMLInputElement) || !t.hasAttribute('data-hb-mix-size')) return;
    var root = t.closest('[data-hb-mix]');
    if (!root || !root.hbMix) return;
    var group = t.closest('[data-hb-mix-sizes]');
    if (!group) return;
    if (group.dataset.hbMixSizes === 'top') pickTopSize(root, t.dataset.hbMixSize);
    else pickBottomSize(root, t.dataset.hbMixSize);
  }
  // The set's key is new for every add (a capture listener runs before the theme's own submit handler reads the form)
  function onSubmit(e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var pi = form.closest('.product-information');
    var root = pi && pi.querySelector('[data-hb-mix][data-ctx="pdp"]');
    if (!root || !root.hbMix) return;
    root.hbMix.key = newKey();
    fillForm(root);
  }

  /* ---------- wiring ---------- */
  function wire(root, onChangeFn) {
    if (!root) return null;
    if (root.hbMix) {
      if (typeof onChangeFn === 'function') root.hbMix.onChange = onChangeFn;
      paint(root);
      return root.hbMix;
    }
    var d = readData(root);
    if (!d || !d.tops.length || !d.bottoms.length) return null;
    var s = {
      ctx: root.dataset.ctx === 'qv' ? 'qv' : 'pdp',
      data: d,
      key: newKey(),
      top: firstOf(d.tops, root.dataset.top),
      topSize: '',
      bottom: firstOf(d.bottoms, ''),
      botSize: '',
      botTouched: false,
      onChange: typeof onChangeFn === 'function' ? onChangeFn : null,
      btnText: '',
      descOrig: null,
    };
    root.hbMix = s;
    var t = topOf(s);
    s.topSize = t ? firstSize(t.variants) : '';
    var b = bottomOf(s);
    s.botSize = b ? nearest(b.variants, s.topSize) : '';
    root.setAttribute('data-hb-mix-ready', '');
    paint(root);
    placeGuide(root);
    return s;
  }
  /* HB 2026-11-02 (the pictures moved under the BOTTOM sizes): the page's SIZE GUIDE button goes into the BOTTOM rows'
     box (snippets/hb-mix, data-hb-mix-guide), so it ends that row and not the pictures. HB 2026-11-03: on the phone
     too, now that the block sits above ADD TO CART there. The button keeps its own click. */
  function placeGuide(root) {
    if (!root || root.dataset.ctx !== 'pdp') return;
    var pi = root.closest('.product-information');
    var box = root.querySelector('[data-hb-mix-guide]');
    var g = pi && pi.querySelector('.hb-size-guide');
    if (!box || !g) return;
    if (g.parentNode !== box) box.appendChild(g);
  }
  /* ---------- the card's quick add (snippets/quick-add-custom, the "+" sheet) ----------
     HB 2026-11-03 (team test of The Escape: the bikini from the "+" and the same bikini from its page looked different
     in the cart): the sheet of a mix & match bikini carries data-hb-mix-parts, each size pair's top and bottom. Its ADD
     TO CART now sends those two pieces marked as one set, as the product page does, instead of the one bundle line.
     This runs in the capture phase, ahead of assets/product-custom.js on the button (which it then stops); the quick
     add's note in assets/hb-cart.js listens on window, earlier still, so the note keeps its name and picture. A pair
     without pieces is left to assets/product-custom.js as before. */
  function qaPair(btn) {
    var wrap = btn.closest('.atc-icon-wrapper');
    if (!wrap) return null;
    var picked = [];
    wrap.querySelectorAll('.custom-size-row.active').forEach(function (b) {
      var pos = Number(b.dataset.optionPosition);
      if (pos) picked[pos - 1] = up(b.dataset.optionValue);
    });
    if (!picked[0] || !picked[1]) return null;
    var variants, parts;
    try {
      variants = JSON.parse(btn.dataset.json || '[]');
      parts = JSON.parse(btn.dataset.hbMixParts || '{}');
    } catch (e) {
      return null;
    }
    var v = variants.filter(function (x) { return up(x.option1) === picked[0] && up(x.option2) === picked[1]; })[0];
    var p = v && parts[String(v.id)];
    if (!v || !v.available || !p || p.length !== 2) return null;
    return { wrap: wrap, top: p[0], bottom: p[1] };
  }
  function onQaAdd(e) {
    var t = e.target instanceof Element ? e.target : null;
    var btn = t && t.closest('.hb-qa__add[data-hb-mix-parts]');
    if (!btn) return;
    var pair = qaPair(btn);
    if (!pair) return;
    e.stopPropagation();
    e.preventDefault();
    var wrap = pair.wrap;
    var popup = wrap.querySelector('.variant-popup');
    var plus = wrap.querySelector('.atc-plus-icon');
    var key = newKey();
    var props = function (role) {
      var p = { _hb_mix: key, _hb_mix_role: role, _hb_mix_top: btn.dataset.hbMixTop || '' };
      if (btn.dataset.hbMixPage) p._hb_mix_page = btn.dataset.hbMixPage;
      return p;
    };
    var state = function (s) {
      if (!plus) return;
      plus.classList.remove('state-default', 'state-loading', 'state-success');
      plus.classList.add('state-' + s);
    };
    state('loading');
    document.body.classList.remove('atc-opened');
    if (popup) popup.classList.remove('active');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          { id: Number(pair.top), quantity: 1, properties: props('top') },
          { id: Number(pair.bottom), quantity: 1, properties: props('bottom') },
        ],
      }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        return r.json();
      })
      .then(function (data) {
        try {
          if (typeof window.triggerKlaviyoAddedToCart === 'function') window.triggerKlaviyoAddedToCart(data);
        } catch (err) {
          /* nothing */
        }
        state('success');
        setTimeout(function () { state('default'); }, 2000);
        document.body.classList.remove('cstm-pro-overlay');
        // The same event assets/product-custom.js sends (CartUpdateEvent of assets/events.js, built by hand: this file
        // is a plain script, and the theme's minifier turns an import() here into require()), so the cart and the
        // quick add's note behave as for any piece
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: { source: 'variant-popup-inner' }, sourceId: undefined, data: {} };
        document.dispatchEvent(ev);
      })
      .catch(function (err) {
        state('default');
        console.error('Cart Error:', err);
      });
  }

  function init() {
    document.querySelectorAll('[data-hb-mix]:not([data-hb-mix-ready])').forEach(function (root) { wire(root, null); });
  }

  document.addEventListener('click', onQaAdd, true);
  document.addEventListener('click', onClick);
  document.addEventListener('change', onChange);
  document.addEventListener('submit', onSubmit, true);
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    var run = function () { pending = false; init(); };
    if (document.hidden) setTimeout(run, 50); else requestAnimationFrame(run);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  init();

  window.HBMix = { version: '2026-11-03-shot14-desc', wire: wire, read: read, items: items, paint: paint, newKey: newKey };
})();
